export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'case-timeline',
    name: '事件经过',
    description: '完整还原李宗瑞案件从发生到曝光的全过程，以时间线方式呈现关键节点',
    icon: 'ri-timeline-view',
  },
  {
    slug: 'legal-analysis',
    name: '法律分析',
    description: '深度解读案件涉及的法律条文、判决理由及司法程序，探讨台湾刑法相关条款',
    icon: 'ri-scales-3-line',
  },
  {
    slug: 'social-impact',
    name: '社会影响',
    description: '分析案件对台湾社会的深远影响，包括媒体生态、公众舆论及法律改革',
    icon: 'ri-global-line',
  },
  {
    slug: 'in-depth-commentary',
    name: '深度评论',
    description: '从性别平等、司法公正、媒体伦理等多维度进行批判性思考与讨论',
    icon: 'ri-article-line',
  },
];